import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { FullWidthVStack } from "@components/common";
import EmailInput from "@components/EmailInput";
import TextInput from "@components/TextInput";
import { useRouter } from "@lib/router";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderFields, ORDER_FIELDS_MAX_LENGTHS } from "../../../constants";

const InvoicePrivateForm: FC = () => {
  const { t } = useTranslation();
  const { defaultLocale } = useRouter();

  return (
    <FullWidthVStack
      maxWidth={responsiveStyle({ mobile: "100%", desktop: "22.25rem" })}
      mb="1rem"
      mt={responsiveStyle({ mobile: "1rem", desktop: "0" })}
      alignSelf="stretch"
    >
      {/* Removed by the requirements only in LT version */}
      {defaultLocale !== "lt" && (
        <Box data-field={OrderFields.INVOICE_NAME}>
          <TextInput
            name={OrderFields.INVOICE_NAME}
            isRequired={false}
            label={t("order-summary-invoice-name_surname")}
            maxLength={ORDER_FIELDS_MAX_LENGTHS.name}
          />
        </Box>
      )}
      <Box data-field={OrderFields.INVOICE_EMAIL}>
        <EmailInput
          name={OrderFields.INVOICE_EMAIL}
          label={t("order-summary-invoice-email_address")}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.email}
        />
      </Box>
    </FullWidthVStack>
  );
};
export default InvoicePrivateForm;
